export enum ViewContentSourceEnum {
  BioDigital = 'biodigital',
  Wikipedia = 'wikipedia',
  // NCI Thesaurus
  NCIT = 'ncit',
}
